import { addDestinatario } from './addDestinatario'
import { getAll } from './getDestinatarios'

export const destinatarioService = {
  add: addDestinatario,
  getAll,
}
